import { useMutation, useQueryClient } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { providerCancelServiceRequest } from "../services/goHireService";

export const useProviderCancelServiceRequest = (requestId: number, options?: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => providerCancelServiceRequest(requestId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.serviceRequest(requestId) });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.orderedRequests() });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.receivedRequests() });
      options?.onSuccess?.();
    },
    onError: () => {},
  });
};
